import React, {useState, useEffect} from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from 'antd'
import {EditOutlined, DeleteOutlined, SearchOutlined} from '@ant-design/icons'
import apiRequest from '../../hooks/ApiRequest'
import Layouts from '../../components/Layouts'
import {toast} from 'react-toastify'
import FieldTypesForm from './AddEditFieldTypes'
import CommonSearch from '../../hooks/Search'

const FieldTypes = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [FieldTypes, setFieldTypes] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)

  useEffect(() => {
    fetchFieldTypes()
  }, [])

  const fetchFieldTypes = async () => {
    setLoading(true)
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/fieldtypes`,
        'GET',
      )
      if (response.success) {
        setFieldTypes(response.data)
      } else {
        // toast.error(response.message || 'Failed to fetch claim limits')
      }
    } catch (error) {
      toast.error('Error fetching Field Types')
    } finally {
      setLoading(false)
    }
  }

  const handleSearch = value => {
    const filterTable = FieldTypes.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    setFieldTypes(filterTable)
  }
  const ClearSerach = () => {
    setSearchTerm('')
    setFieldTypes(FieldTypes)
    fetchFieldTypes()
  }
  const handleCreate = () => {
    setSelectedId(null)
    setModalVisible(true)
  }

  const handleEdit = id => {
    setSelectedId(id)
    setModalVisible(true)
  }

  const handleDelete = async id => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/delete/fieldtype/${id}`,
        'POST',
      )
      if (response.success) {
        toast.success('Field Type deleted')
        fetchFieldTypes()
      } else {
        toast.error(response.message || 'Delete failed')
      }
    } catch (error) {
      toast.error('Error deleting Field Type')
    }
  }

  const handleModalClose = () => {
    setModalVisible(false)
    fetchFieldTypes()
  }

  const columns = [
    {
      title: 'Field Type Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <Button type="primary" onClick={() => handleEdit(record.id)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title="Are you sure to delete this Field?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No">
            <Tooltip title="Delete">
              <Button type="danger" style={{marginLeft: 8}}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ]

  return (
    <div title="Claim Limits" className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={24} lg={6} xl={12}>
            <div className="section-top-heading">
              <h3
                style={{
                  color: '#0C1362',
                  fontWeight: '600',
                  fontSize: '20px',
                }}>
                Claim Type Form Fields
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={5}>
            <CommonSearch
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              onSearch={handleSearch}
              onClear={ClearSerach}
            />
          </Col>
          <Col xs={10} sm={10} md={6} lg={3} xl={3}>
            <Button type="primary" onClick={() => handleSearch(searchTerm)}>
              Search
            </Button>
          </Col>
          <Col xs={14} sm={14} md={6} lg={5} xl={4}>
            <Button type="primary" onClick={handleCreate}>
              Add Field Type
            </Button>
          </Col>
        </Row>
      </div>
      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{marginTop: 20}}
        />
      ) : (
        <Table columns={columns} dataSource={FieldTypes} rowKey="id" />
      )}

      <Modal
        title={selectedId ? 'Edit Field' : 'Add Field'}
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}>
        <FieldTypesForm
          fieldTypeId={selectedId}
          modalVisible={modalVisible}
          onSuccess={handleModalClose}
        />
      </Modal>
    </div>
  )
}

export default FieldTypes
